import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import { red } from '@mui/material/colors';

const CloseX = ({...props}) => {

    return(
        <CloseIcon 
            sx={{ color: red[800] }} 
            onClick={props.function} 
            style={{position: 'absolute !important', top: '0', right: '0'}}
            className="remove-product-image"
            />
    )
}
export default CloseX;
